import { render, staticRenderFns } from "./FormFilterTransference.vue?vue&type=template&id=2297fc6e"
import script from "./FormFilterTransference.vue?vue&type=script&lang=js"
export * from "./FormFilterTransference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports